import { Component } from "@angular/core";
import { AuthService } from "src/app/services/auth/auth.service";
import { StyleService } from "src/app/services/style/style.service";

@Component({
    selector: "app-password-reset-complete",
    templateUrl: "./password-reset-complete.component.html",
    styleUrls: [ "./password-reset-complete.component.scss" ]
})
export class PasswordResetCompleteComponent {
    protected readonly brandImage: string;
    protected readonly brandName: string;

    public constructor(styleService: StyleService, authService: AuthService) {
        this.brandImage = styleService.getLogoUrl();
        this.brandName = authService.getTenantName();
    }
}
